export default __webpack_public_path__ + "7273fadce89da05535e5a9eda9652da1.svg";